// extracted by mini-css-extract-plugin
export default {"title":"V2QunOisNq3oDi8jTOvt","title-text":"VECeOeNb2NoqswyOMRHB","title-guide":"GVXQoSKomP6aWMndLsee","body":"cJIkwTkTasnRwBePg_z9","label":"uUj51fE17aSm8iL1sH5z"};